// extracted by mini-css-extract-plugin
export default {"container":"news_container__ypZ9b","card":"news_card__wOCvk","actions":"news_actions__FVWSU","title":"news_title__Tkn+6","date":"news_date__lMFyy","content":"news_content__tOlmO"};